import { twMerge } from "tailwind-merge";
import Typography from "../Typography";

interface BadgeProps {
  variant?: "success" | "warning" | "error" | "info" | "neutral";
  className?: string;
  children?: React.ReactNode;
}

const VARIANTS: Record<string, string> = {
  success: "bg-success-soft text-success-soft-surface",
  warning: "bg-warning-soft text-warning-soft-surface",
  error: "bg-error-soft text-error-soft-surface",
  info: "bg-info-soft text-info-soft-surface",
  neutral: "bg-dark-12 text-black-64",
};

// Standard severity/status pill — replaces plain colored text used ad hoc for
// damage-level and status indicators.
const Badge = ({ variant = "neutral", className, children }: BadgeProps) => {
  return (
    <span
      className={twMerge([
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1",
        VARIANTS[variant],
        className,
      ])}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current shrink-0" />
      <Typography variant="Label" size="lg" className="whitespace-nowrap">
        {children}
      </Typography>
    </span>
  );
};

export default Badge;
